import {Command} from "./Command";
import {GamePlay} from "../model/game-play";
import {toggleYardLine} from "../helpers/distance";
import {ODK} from "../model/odk";
import {FirstDownCommand} from "./FirstDownCommand";
import {SetOdkCommand} from "./SetOdkCommand";
import {SetYardLineCommand} from "./SetYardLineCommand";
import { GroupCommands } from './GroupCommands';

export class SwitchTeamsCommand implements Command {
  private commands: Command[] = [];

  constructor(
    private gamePlay: GamePlay, //nextGamePlay
    private lastGamePlay: GamePlay
  ) { }

  execute() {
    console.log('COMMAND SwitchTeamsCommand')

    if (this.lastGamePlay.gnLs === undefined) {
      throw new Error('GamePlay sans gnLs')
    }

    let nextOdk = this.lastGamePlay.odk === ODK.Offensive
      ? ODK.Defensive
      : ODK.Offensive;

    // this.toggleTeam(this.gamePlay, this.lastGamePlay);
    // if (!lastGamePlay) {
    //   lastGamePlay = this.getLastCompleteGamePlay()
    // }

    if (this.lastGamePlay.odk === ODK.Kick) {
      nextOdk =  this.gamePlay.odk === ODK.Offensive ? ODK.Defensive : ODK.Offensive
    }

    const nextYardLine = toggleYardLine(this.gamePlay.yardLine!)
    this.commands.push(
      new GroupCommands(`SwitchTeamsCommand`, [
        new SetOdkCommand(this.gamePlay, nextOdk),
        new FirstDownCommand(this.gamePlay),
        new SetYardLineCommand(this.gamePlay, nextYardLine)
      ])
    )

    for (const command of this.commands) {
      command.execute();
    }
  }
}
